export const presentationTitle = "Jornada";
export const booksTitle = "Livros";
export const calculatorTitle = "Investimentos";
export const programsTitle = "Programas";
export const articlesTitle = "Artigos";
